var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOcr = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#FFC1C1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18159_5178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 13.3333C18.6673 15.8474 18.6673 17.1045 17.8863 17.8855C17.1052 18.6666 15.8481 18.6666 13.334 18.6666",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 18.6666C8.15316 18.6666 6.89608 18.6666 6.11503 17.8855C5.33398 17.1045 5.33398 15.8474 5.33398 13.3333",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6673 5.33325C8.15316 5.33325 6.89608 5.33325 6.11503 6.1143C5.33398 6.89535 5.33398 8.15243 5.33398 10.6666",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 14L16 14",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12L16 12",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10L16 10",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.334 5.33325C15.8481 5.33325 17.1052 5.33325 17.8863 6.1143C18.6673 6.89535 18.6673 8.15243 18.6673 10.6666",
    stroke: "#1D1D1D",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18159_5178"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 16,
    height: 16,
    rx: 5,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOcr);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ocr.8f4b9ef8573d7f5ea16e00a091340051.svg";